import type { Observable as ObservableType } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import fetchJson$ from '@atlassian/jira-fetch/src/utils/as-json-stream.tsx';
import { TRACE_ID_HEADER } from '@atlassian/jira-fetch/src/utils/constants.tsx';
import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import type {
	ConfluencePermissionsResponse,
	UserPropertiesResponse,
	ConfluenceSpacesResponse,
} from './types.tsx';

export function fetchConfluencePermissions(): ObservableType<ConfluencePermissionsResponse> {
	return fetchJson$('/wiki/rest/api/user/current?expand=operations');
}

export function fetchConfluenceSpace(): ObservableType<ConfluenceSpacesResponse> {
	return fetchJson$('/wiki/api/v2/spaces?limit=1');
}

export function fetchUserProperties(accountId: string): ObservableType<UserPropertiesResponse> {
	return fetchJson$(
		`/rest/api/3/user/properties/viewedJswWhiteboardPulse?accountId=${encodeURIComponent(accountId)}`,
	);
}

export function setUserProperties(accountId: string, value: boolean): ObservableType<boolean> {
	const url = `/rest/api/3/user/properties/viewedJswWhiteboardPulse?accountId=${encodeURIComponent(accountId)}`;
	return of(url)
		.mergeMap(() =>
			fetch(url, {
				method: 'PUT',
				body: JSON.stringify(value),
			}),
		)
		.mergeMap((response) => {
			if (!response.ok) {
				const { status } = response;
				response.text().then((str) => {
					const traceId = response.headers.get(TRACE_ID_HEADER);
					if (traceId != null && traceId !== '') {
						throw new FetchError(status, str, traceId);
					} else {
						throw new FetchError(status, str);
					}
				});
				return of(false);
			}

			return of(value);
		});
}
